import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import * as adult from './../../../../data/selfassesment-adult.json';
import * as seniorAdult from './../../../../data/selfassesment-senior.json';
import * as adolescent from './../../../../data/selfassesment-adolescent.json';
import * as depression from './../../../../data/selfassesment-depression-anxiety.json';
import * as commonQues from './../../../../data/selfassesment-common-questions.json';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RolesData } from '../../../../@core/interfaces/common/roles';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { NbTabComponent, NbTabsetComponent } from '@nebular/theme';
import { DateService } from '../service/date.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'ngx-assesment',
  templateUrl: './assesment.component.html',
  styleUrls: [
    './assesment.component.scss',
    '../../../../../assets/css/patient-portal.css',
    './assesment-caresphere-theme.scss',
    './assesment-wellspring-theme.scss',
  ]
})
export class AssesmentComponent implements OnInit {

  // Set via route `data: { theme: 'care-sphere' }` (see care-sphere-routing.module.ts).
  // Defaults to the existing Patient Portal look when absent - the patient-portal
  // route intentionally carries no `theme` data, so that flow is unaffected.
  isCareSphereTheme: boolean = this.route?.snapshot?.data?.theme === 'care-sphere';
  // Set via route `data: { theme: 'well-spring' }` (see well-spring-routing
  // .module.ts) - same pattern as isCareSphereTheme above, a separate theme
  // rather than reusing the Care-Sphere one, per assesment-wellspring-theme.scss.
  isWellSpringTheme: boolean = this.route?.snapshot?.data?.theme === 'well-spring';

  isIntro: boolean = false;
  isSelf: boolean = false;
  isCompleted: boolean = false;
  isStart: boolean = false;
  isResult: boolean = false;
  showSymptoms: boolean = false;
  @ViewChild("tabSetRef") tabsetE: NbTabsetComponent;
  @ViewChild("history") historyTab: NbTabComponent;

  allQuestions: Array<any> = [];
  commonQuestions: any = (commonQues as any).default;
  allAdult: any = (adult as any).default;
  allSenior: any = (seniorAdult as any).default;
  allAdolescent: any = (adolescent as any).default;
  allDepression: any = (depression as any).default;
  commonQues: Array<any> = [];
  languageVar: any = {};
  commonLanguageVar: any = {};
  introImg: string;
  currentIndex: number = 0;
  selfAssesmentForm: FormGroup;
  @Output() logInForm: EventEmitter<any> = new EventEmitter<any>();
  @Output() signUpForm: EventEmitter<any> = new EventEmitter<any>();
  totalScore: number = 0;
  anxietyScore: number = 0;
  protected readonly unsubscribe$ = new Subject<void>();
  regID: string = localStorage.getItem('regID');
  assessmentType: string;
  assesmentHistory: Array<any> = [];
  age: number = Number(localStorage.getItem('age'));
  stressLastCompletedDate: Date;
  DepressioLastCompletedDate: Date;
  CognitiveLastCompletedDate: Date;
  MentalLastCompletedDate: Date;
  isStressUnlockedFlag: boolean = true;
  daysToUnlockForStress: number = 0;
  selectedCompletedAssesment: any;

  isDepressionUnlockedFlag: boolean = true;
  daysToUnlockForDepression: number = 0;

  isCognitiveUnlockedFlag: boolean = true;
  daysToUnlockForCognitive: number = 0;

  isMentalUnlockedFlag: boolean = true;
  daysToUnlockForMental: number = 0;

  visitNoForStress: number = 0;
  visitNoForDepression: number = 0;
  visitNoForCognitive: number = 0;
  visitNoForMental: number = 0;
  p: number = 1;
  constructor(public dateobj: DateService, private rolesData: RolesData, private fb: FormBuilder, private route: ActivatedRoute) {
    this.selfAssesmentForm = this.fb.group({
      language: this.fb.control('English')
    });
  }

  ngOnInit(): void {
    this.isStart = true;
    this.getAssesmentHistory();
  }

  getAssesmentHistory() {
    this.rolesData?.list(`PatientAssessment/GetPatientAssessmentById/${environment.virtualTenant}/${environment.virtualBranch}/${this.regID}`).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (data: any) => {
        if (data && data.details) {
          const assesmentHistory = data.details;
          assesmentHistory.forEach(element => {
            element.inputJson = JSON.parse(element.inputJson || '{}');
          });

          if (this.age >= 18 && this.age < 65) {
            this.assesmentHistory = assesmentHistory?.filter(each => each.assessmentType === 'Stress' || 'Depression & Anxiety').sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());

            const stressHistory = this.assesmentHistory?.filter(each => each.assessmentType === 'Stress');
            this.visitNoForStress = stressHistory?.length;
            this.stressLastCompletedDate = stressHistory && stressHistory.length > 0 ? this.utcToLocalConversion(stressHistory[0]?.createdDate) : null;

            if (this.stressLastCompletedDate) {
              const today = new Date();
              const diffInMs = today.getTime() - new Date(this.stressLastCompletedDate).getTime();
              const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
              this.daysToUnlockForStress = 15 - diffInDays;
              this.isStressUnlockedFlag = diffInDays >= 15;
            } else {
              this.isStressUnlockedFlag = true;
              this.daysToUnlockForStress = 0;
            }


            const depressionHistory = this.assesmentHistory?.filter(each => each.assessmentType === 'Depression & Anxiety');
            this.visitNoForDepression = depressionHistory?.length;
            this.DepressioLastCompletedDate = depressionHistory && depressionHistory.length > 0 ? this.utcToLocalConversion(depressionHistory[0]?.createdDate) : null;
            if (this.DepressioLastCompletedDate) {
              const today = new Date();
              const diffInMs = today.getTime() - new Date(this.DepressioLastCompletedDate).getTime();
              const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
              this.daysToUnlockForDepression = 15 - diffInDays;
              this.isDepressionUnlockedFlag = diffInDays >= 15;
            } else {
              this.isDepressionUnlockedFlag = true;
              this.daysToUnlockForDepression = 0;
            }

          }
          else if (this.age < 18) {
            this.assesmentHistory = assesmentHistory?.filter(each => each.assessmentType === 'Mental Health & Behavior').sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
            this.visitNoForMental = this.assesmentHistory?.length;
            this.MentalLastCompletedDate = this.assesmentHistory && this.assesmentHistory.length > 0 ? this.utcToLocalConversion(this.assesmentHistory[0]?.createdDate) : null;
            if (this.MentalLastCompletedDate) {
              const today = new Date();
              const diffInMs = today.getTime() - new Date(this.MentalLastCompletedDate).getTime();
              const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
              this.daysToUnlockForMental = 15 - diffInDays;
              this.isMentalUnlockedFlag = diffInDays >= 15;
            } else {
              this.isMentalUnlockedFlag = true;
              this.daysToUnlockForMental = 0;
            }
          }
          else {
            this.assesmentHistory = assesmentHistory?.filter(each => each.assessmentType === 'Mental Well-being & Cognitive Health').sort((a, b) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
            this.visitNoForCognitive = this.assesmentHistory?.length;
            this.CognitiveLastCompletedDate = this.assesmentHistory && this.assesmentHistory.length > 0 ? this.utcToLocalConversion(this.assesmentHistory[0]?.createdDate) : null;
            if (this.CognitiveLastCompletedDate) {
              const today = new Date();
              const diffInMs = today.getTime() - new Date(this.CognitiveLastCompletedDate).getTime();
              const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
              this.daysToUnlockForCognitive = 15 - diffInDays;
              this.isCognitiveUnlockedFlag = diffInDays >= 15;
            } else {
              this.isCognitiveUnlockedFlag = true;
              this.daysToUnlockForCognitive = 0;
            }
          }

        }
      }
    );
  }

  chooseLanguageCode(language) {
    return language == 'Tamil' ? 'TAM' : language == 'English' ? 'ENG' : language == 'Hindi' ? 'HIN' : language == 'Kannada' ? 'KAN' : language == 'Malayalam' ? 'MAL' : language == 'Marathi' ? 'MAR' : language == 'Telugu' ? 'TEL' : '';
  }


  clickCompletedAssesment(assesment) {
    this.selectedCompletedAssesment = assesment;
  }

  clickAssesment(type) {
    const languageSelected = this.selfAssesmentForm?.get('language')?.value;
    this.commonLanguageVar = this.commonQuestions?.[languageSelected];
    this.commonQues = this.commonLanguageVar?.quesAndOptions || [];

    if (type == 'ADULT') {
      this.assessmentType = 'Stress';
      this.introImg = this.allAdult?.introImg;
      this.languageVar = this.allAdult?.[languageSelected];
    }
    else if (type == 'DEPRESSION') {
      this.assessmentType = 'Depression & Anxiety';
      this.introImg = this.allDepression?.introImg;
      this.languageVar = this.allDepression?.[languageSelected];
    }
    else if (type == 'SENIOR ADULT') {
      this.assessmentType = 'Mental Well-being & Cognitive Health';
      this.introImg = this.allSenior?.introImg;
      this.languageVar = this.allSenior?.[languageSelected];
    }
    else if (type == 'ADOLESCENT') {
      this.assessmentType = 'Mental Health & Behavior';
      this.introImg = this.allAdolescent?.introImg;
      this.languageVar = this.allAdolescent?.[languageSelected];
    }


    this.rolesData?.list(`tenants/${environment.patientTenantId}/masterreason/${environment.patientBranchId}/getAllTenantLessMaster?isActive=true
`).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (data: any) => {
        if (data && data.details) {

          const langCode = this.chooseLanguageCode(languageSelected);
          let anxietyQuestions = [];
          const allQuestions = data.details?.filter(each => each.mrType === type && each.isActive == true && each.reasonCode?.startsWith(langCode))?.sort((a, b) => {
            const numA = parseInt(a.reasonCode.replace(/\D/g, ''), 10);
            const numB = parseInt(b.reasonCode.replace(/\D/g, ''), 10);
            return numA - numB;
          });

          if (type == 'DEPRESSION') {
            anxietyQuestions = data.details?.filter(each => each.mrType === 'ANXIETY' && each.isActive == true && each.reasonCode?.startsWith(langCode))?.sort((a, b) => {
              const numA = parseInt(a.reasonCode.replace(/\D/g, ''), 10);
              const numB = parseInt(b.reasonCode.replace(/\D/g, ''), 10);
              return numA - numB;
            });;
          }

          allQuestions?.forEach((item, index) => {
            item.options = JSON.parse(item?.reasonDescription || '[]');
            this.selfAssesmentForm.addControl('question' + index, this.fb.control(''));
          });

          if (type == 'DEPRESSION' && anxietyQuestions && anxietyQuestions.length > 0) {
            anxietyQuestions?.forEach((item, index) => {
              item.options = JSON.parse(item?.reasonDescription || '[]');
              this.selfAssesmentForm.addControl('question' + (allQuestions.length + index), this.fb.control(''));
            });
            allQuestions.push(...anxietyQuestions);
          }

          this.allQuestions = allQuestions;
          this.isStart = false;
          this.isIntro = true;
        }
      }
    );
  }

  utcToLocalConversion(date) {
    if (date != null && date != "" && date != undefined) {
      return this.dateobj.dateUtctoLocalDateAndTime(date);
    }
  }

  clickIntroNext() {
    if (this.allQuestions && this.allQuestions.length > 0) {
      this.isIntro = false;
      this.isSelf = true;
    }
  }

  clickIntroBack() {
    this.isIntro = false;
    this.isStart = true;
    this.selfAssesmentForm?.reset({
      language: 'English'
    });
  }

  clickSelfNext() {
    if (this.currentIndex >= this.allQuestions?.length - 1) {
      this.isSelf = false;
      this.isResult = true;
      this.currentIndex = 0;
      this.submitSelfAssessment();
    } else {
      this.currentIndex++;
    }
  }

  onTabChange(val) {
    if (val.tabTitle == 'Assessment History' && this.assesmentHistory && this.assesmentHistory.length > 0) {
      this.selectedCompletedAssesment = this.assesmentHistory[0];
    }
  }

  getDepressionLevel(x) {
   return x.inputJson.depressionScore == 0
      ? 'No Symptoms'
      : x.inputJson.depressionScore >= 1 && x.inputJson.depressionScore <= 4
        ? 'Minimal' : x.inputJson.depressionScore >= 5 &&
          x.inputJson.depressionScore <= 9 ? 'Mild' :
          x.inputJson.depressionScore >= 10 && x.inputJson.depressionScore
            <= 14 ? 'Moderate' : x.inputJson.depressionScore >= 15 &&
              x.inputJson.depressionScore <= 19 ? 'Moderately Severe' :
            x.inputJson.depressionScore >= 20 &&
              x.inputJson.depressionScore <= 27 ? 'Severe' : '';
  }

  getAnxietyLevel(x) {
    return x.inputJson.anxietyScore == 0
    ? 'No Symptoms'
    : x.inputJson.anxietyScore >= 1 && x.inputJson.anxietyScore <= 4
        ? 'Minimal' : x.inputJson.anxietyScore>= 5 &&
        x.inputJson.anxietyScore <= 9 ? 'Mild' : x.inputJson.anxietyScore>=
            10 && x.inputJson.anxietyScore <= 14 ? 'Moderate' :
                x.inputJson.anxietyScore>= 15 && x.inputJson.anxietyScore <=
                    21 ? 'Severe' : '';
   }

   getStressLevel(x) {
    return x.score == 0
    ? 'No Symptoms'
    : x.score >= 1 && x.score <= 4
        ? 'Mild' : x.score>= 5 && x.score <= 14 ? 'Moderate' :
                x.score>= 15 && x.score <=
                    33 ? 'Significant' : '';
   }

  submitSelfAssessment() {
    this.totalScore = 0;

    this.allQuestions.forEach((q, i) => {
      const selectedId = this.selfAssesmentForm.get('question' + i)?.value;
      if (selectedId) {
        const selectedOption = q.options.find((opt) => opt.id == selectedId);
        if (selectedOption) {
          if (q?.mrType == 'ANXIETY') {
            this.anxietyScore += selectedOption.score;
          }
          else {
            this.totalScore += selectedOption.score;
          }
        }
      }
    });

    let inputJson = this.selfAssesmentForm.value;

    if (this.assessmentType == 'Depression & Anxiety') {
      inputJson = {
        ...inputJson,
        depressionScore: this.totalScore,
        anxietyScore: this.anxietyScore
      };
      this.totalScore += this.anxietyScore;
    }

    const visitNo = this.assessmentType === 'Stress' ? this.visitNoForStress + 1 : this.assessmentType === 'Depression & Anxiety' ? this.visitNoForDepression + 1 : this.assessmentType === 'Mental Well-being & Cognitive Health' ? this.visitNoForCognitive + 1 : this.visitNoForMental + 1;

    let payload = {
      regId: this.regID,
      visit: visitNo,
      inputJson: JSON.stringify(inputJson),
      assessmentType: this.assessmentType,
      score: this.totalScore || 0,
      doctorVisibility: true,
      tenantId: environment.virtualTenant,
      branchId: environment.virtualBranch,
      createdDate: new Date()
    }

    this.rolesData?.create(`${environment.apiUrl}/PatientAssessment/postPatientAssessment`, payload).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (data: any) => {
        if (data && data.details ) {
          this.getAssesmentHistory();

          let response=data.details;

          response={
            ...response,
            inputJson : JSON.parse(response.inputJson || '{}')
          }
        
          this.selectedCompletedAssesment = response;

          this.isResult = true;
          this.isSelf = false;
        }
      }
    )

  }

  moreAboutSympList:Array<any>=[];

  clickMore(type) {
    if(type=='Stress'){
      this.moreAboutSympList=this.getStressSymptoms();
    }
    else if(type=='Depression'){
      this.moreAboutSympList=this.getDepressionSymptoms();
    }
    else if(type=='Depression & Anxiety'){
      this.moreAboutSympList=this.getAnxietySymptoms();
    }
    this.showSymptoms = true;
  }

  closeSymp(){
    this.moreAboutSympList=[];
    this.showSymptoms=false;
  }

  goToAssesmentHistory() {
    this.isResult = false;
    this.isStart = true;
    setTimeout(() => {
      this.tabsetE?.selectTab(this.historyTab);
    }, 500);
  }

  seeScore() {
    this.isStart = false;
    this.isResult = true;
  }


  clickSelfBack() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
    else {
      this.isSelf = false;
      this.isIntro = true;
      this.allQuestions?.forEach((q, index) => {
        this.selfAssesmentForm?.get('question' + index)?.setValue('');
      });
    }
  }


  getDaysSinceLastStress(): number {
    if (!this.stressLastCompletedDate) return 100; 
    const today = new Date();
    const last = new Date(this.stressLastCompletedDate);
    const diffInMs = today.getTime() - last.getTime();
    return Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  }

  getDaysToUnlock(): number {
    const remaining = 15 - this.getDaysSinceLastStress();
    return remaining > 0 ? remaining : 0;
  }

  isStressUnlocked(): boolean {
    return this.getDaysToUnlock() === 0;
  }

  getScores(x) {
    const scores = [];
  
    if (x.assessmentType === 'Depression & Anxiety') {
      const depLevel = this.getDepressionLevel(x);
      const anxLevel = this.getAnxietyLevel(x);
  
      scores.push({
        label: 'DEPRESSION',
        value: depLevel,
        barClass: depLevel === 'No Symptoms' ? 'bar-1' :
                  depLevel === 'Minimal' ? 'bar-2' :
                  depLevel === 'Mild' ? 'bar-3' :
                  depLevel === 'Moderate' ? 'bar-4' :
                  depLevel === 'Moderately Severe' ? 'bar-5' :
                  depLevel === 'Severe' ? 'bar-6' : ''
      });
  
      scores.push({
        label: 'ANXIETY',
        value: anxLevel,
        barClass: anxLevel === 'No Symptoms' ? 'bar-1' :
                  anxLevel === 'Minimal' ? 'bar-2' :
                  anxLevel === 'Mild' ? 'bar-3' :
                  anxLevel === 'Moderate' ? 'bar-4' :
                  anxLevel === 'Severe' ? 'bar-6' : ''
      });
    }
  
    if (x.assessmentType === 'Stress') {
      const stressLevel = this.getStressLevel(x);
  
      scores.push({
        label: 'STRESS',
        value: stressLevel,
        barClass: stressLevel === 'No Symptoms' ? 'bar-1' :
                  stressLevel === 'Mild' ? 'bar-2' :
                  stressLevel === 'Moderate' ? 'bar-4' :
                  stressLevel === 'Significant' ? 'bar-6' : ''
      });
    }
  
    return scores;
  }
  
  get aboutSymptoms() {
    if (this.selectedCompletedAssesment?.assessmentType=='Depression & Anxiety') {
      return [
        ...this.getDepressionSymptoms(),
        ...this.getAnxietySymptoms()
      ];
    }
  
    if (this.selectedCompletedAssesment?.assessmentType=='Stress') {
      return this.getStressSymptoms();
    }
  
    return null;
  }

  getAnxietySymptoms(){
    return [
      {
        title: 'No Symptoms of Anxiety',
        range: '(0)',
        text: this.allDepression?.noSymptomsAnxiety
      },
      {
        title: 'Minimal Anxiety',
        range: '(1-4)',
        text: this.allDepression?.minimalAnxiety
      },
      {
        title: 'Mild Anxiety',
        range: '(5-9)',
        text:this.allDepression?.mildAnxiety
      },
      { title: 'Moderate Anxiety',
        range: '(10-14)',
        text: this.allDepression?.moderateAnxiety
      },
      {
        title: 'Severe Anxiety',
        range: '(15-21)',
        text:this.allDepression?.severeAnxiety
      }
    ];
  }

  getDepressionSymptoms(){
    return [
      {
        title: 'No Symptoms of Depression',
        range: '(0)',
        text: this.allDepression?.noSymptomsDepression
      },
      {
        title: 'Minimal Depression',
        range: '(1-4)',
        text: this.allDepression?.minimalDepression
      },
      {
        title: 'Mild Depression',
        range: '(5-9)',
        text:this.allDepression?.mildDepression
      },
      { title: 'Moderate Depression',
        range: '(10-14)',
        text: this.allDepression?.moderateDepression
      },
      {
        title: 'Moderate to Severe Depression',
        range: '(15-19)',
        text:this.allDepression?.moderateSevereDepression
      },
      { title: 'Severe Depression',
        range: '(20-27)',
        text: this.allDepression?.severeDepression
      }
    ];
  }


  getStressSymptoms(){
           return [
            {
              title: 'No Symptoms of Stress',
              range: '(0)',
              text: this.allAdult?.noSymptoms
            },
            {
              title: 'Mild Stress',
              range: '(1-4)',
              text: this.allAdult?.mild
            },
            {
              title: 'Moderate Stress',
              range: '(5-14)',
              text:this.allAdult?.moderate
            },
            { title: 'Significant Stress',
              range: '(15-33)',
              text: this.allAdult?.significiant
            }
          ];
  }

  getDepressionDescription(data){
    const symp= this.getDepressionLevel(data);
    return symp == 'No Symptoms' ? this.allDepression?.noSymptomsDepression : symp == 'Minimal' ? this.allDepression?.minimalDepression : symp == 'Mild' ? this.allDepression?.mildDepression : symp == 'Moderate' ? this.allDepression?.moderateDepression : symp == 'Moderately Severe' ? this.allDepression?.moderateSevereDepression : symp == 'Severe' ? this.allDepression?.severeDepression : '';
  }

  getAnxietyDescription(data){
    const symp= this.getAnxietyLevel(data);
    return symp == 'No Symptoms' ? this.allDepression?.noSymptomsAnxiety : symp == 'Minimal' ? this.allDepression?.minimalAnxiety : symp == 'Mild' ? this.allDepression?.mildAnxiety : symp == 'Moderate' ? this.allDepression?.moderateAnxiety : symp == 'Severe' ? this.allDepression?.severeAnxiety : '';
  }

  getStressDescription(data){
        const symp= this.getStressLevel(data);
        return symp == 'No Symptoms' ? this.allAdult?.noSymptoms : symp == 'Mild' ? this.allAdult?.mild : symp == 'Moderate' ? this.allAdult?.moderate : symp == 'Significant' ? this.allAdult?.significiant : '';
  }
  


}
